import { Grid, styled } from '@mui/material';
import { moneyFormat } from '../../../../utils/appUtils';

export const CoverageSubValue = ({
  label,
  value,
}: {
  label: string;
  value?: number;
}) => {
  return (
    <>
      <Grid item sm={7} style={{ display: 'flex', alignItems: 'center' }}>
        <IndentedLabel>{label}</IndentedLabel>
      </Grid>
      <Grid
        item
        sm={5}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          paddingRight: 10,
        }}
      >
        {value != null && moneyFormat(value)}
      </Grid>
    </>
  );
};

const IndentedLabel = styled('span')(({ theme }) => ({
  paddingLeft: '3.4rem',
  color: theme.palette.text.text8,
}));
